import { of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';
import { ConstantValues } from '../bpg-common/models/bpg-constants';
import { BpgCommonService } from '../bpg-common/services/bpg-common.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../bpg-common/services/bpg-common.service";
var HoshinBudgetService = /** @class */ (function () {
    function HoshinBudgetService(http, bpgCommonService) {
        this.http = http;
        this.bpgCommonService = bpgCommonService;
        this.URI = ConstantValues.financeManagementApiUrl.financeManagementUrl;
        this.saveBudgetUrl = ConstantValues.financeManagementApiUrl.saveBudgetUrl;
        this.getHoshinsUrl = ConstantValues.financeManagementApiUrl.getHoshinsUrl;
        this.getCloneHoshinsUrl = ConstantValues.financeManagementApiUrl.cloneHoshineUrl;
        this.getBudgetList = ConstantValues.financeManagementApiUrl.getBudget;
        this.deleteBudgetUrl = ConstantValues.financeManagementApiUrl.deleteBudget;
        this.getBaseHoshinMasterForHoshinIdUrl = ConstantValues.financeManagementApiUrl.getBaseHoshinMasterForHoshinId;
        this.getHoshinForSingleUserUrl = ConstantValues.financeManagementApiUrl.getHoshinForSingleUser;
        this.getKpiDetailsUrl = ConstantValues.financeManagementApiUrl.getKpiDetails;
        this.getHoshinYearsUrl = ConstantValues.financeManagementApiUrl.getHoshinYears;
        this.saveHoshinReviewUrl = ConstantValues.financeManagementApiUrl.saveHoshinReview;
        this.saveHoshinGoalsUrl = ConstantValues.financeManagementApiUrl.saveHoshinGoals;
        this.saveHoshinInitiativeUrl = ConstantValues.financeManagementApiUrl.saveHoshinInitiative;
        this.saveHoshinKpiUrl = ConstantValues.financeManagementApiUrl.saveHoshinKpi;
        this.deleteHoshinInitativeUrl = ConstantValues.financeManagementApiUrl.deleteHoshinInitative;
        this.deleteHoshinKpiUrl = ConstantValues.financeManagementApiUrl.deleteHoshinKpi;
        this.cloneHoshinsUrl = ConstantValues.financeManagementApiUrl.cloneHoshins;
        this.approveorRejectHoshinUrl = ConstantValues.financeManagementApiUrl.approveorRejectHoshin;
        this.submitHoshinUrl = ConstantValues.financeManagementApiUrl.submitHoshin;
        this.getPastHoshinsUrl = ConstantValues.financeManagementApiUrl.getPastHoshins;
        this.getHoshinChaptersUrl = ConstantValues.financeManagementApiUrl.getHoshinChapters;
        this.getAllChapterBudgetStatusesUrl = ConstantValues.financeManagementApiUrl.getAllChapterBudgetStatuses;
    }
    /** For service call to save budget and hoshin
    * @class HoshinBudgetService
    * @method saveBudget
    * @param hoshinBudgetDTO
    * @returns Observable
    */
    HoshinBudgetService.prototype.saveBudget = function (hoshinBudgetDTO) {
        return this.http.post(this.URI + this.saveBudgetUrl, hoshinBudgetDTO, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            throw of(error);
        }));
    };
    /** For service call to get hoshins
    * @class HoshinBudgetService
    * @method getHoshins
    * @param budgetId
    * @returns Observable
    */
    HoshinBudgetService.prototype.getHoshins = function (budgetId) {
        return this.http.post(this.URI + this.getHoshinsUrl, budgetId, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            throw of(error);
        }));
    };
    /** For service call to get hoshins
  * @class HoshinBudgetService
  * @method getHoshinForSingleUser
  * @param userId
  * @returns Observable
  */
    HoshinBudgetService.prototype.getHoshinForSingleUser = function (hoshinData) {
        return this.http.post(this.URI + this.getHoshinForSingleUserUrl, hoshinData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            throw of(error);
        }));
    };
    /** For service call to get hoshins
  * @class HoshinBudgetService
  * @method getHoshinYears
  * @param userId
  * @returns Observable
  */
    HoshinBudgetService.prototype.getHoshinYears = function (userData) {
        return this.http.post(this.URI + this.getHoshinYearsUrl, userData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            throw of(error);
        }));
    };
    /** For service call to get hoshins
* @class HoshinBudgetService
* @method getHoshinYears
* @param userId
* @returns Observable
*/
    HoshinBudgetService.prototype.getPastHoshins = function (hoshinData) {
        return this.http.post(this.URI + this.getPastHoshinsUrl, hoshinData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            throw of(error);
        }));
    };
    /** For service call to get hoshins
  * @class HoshinBudgetService
  * @method getHoshinForSingleUser
  * @param userId
  * @returns Observable
  */
    HoshinBudgetService.prototype.getKpiDetails = function (businessDrivers) {
        return this.http.get(this.URI + this.getKpiDetailsUrl + businessDrivers, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            throw of(error);
        }));
    };
    /** For service call to clone hoshins
  * @class HoshinBudgetService
  * @method cloneHoshins
  * @param cloneData
  * @returns Observable
  */
    HoshinBudgetService.prototype.cloneHoshins = function (cloneData) {
        return this.http.post(this.URI + this.cloneHoshinsUrl, cloneData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            throw of(error);
        }));
    };
    /** For service call to save hoshin review
  * @class HoshinBudgetService
  * @method saveHoshinReview
  * @param reviewData
  * @returns Observable
  */
    HoshinBudgetService.prototype.saveHoshinReview = function (reviewData) {
        return this.http.post(this.URI + this.saveHoshinReviewUrl, reviewData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            throw of(error);
        }));
    };
    /** For service call to save hoshin review
* @class HoshinBudgetService
* @method saveHoshinReview
* @param reviewData
* @returns Observable
*/
    HoshinBudgetService.prototype.submitHoshin = function (reviewData) {
        return this.http.post(this.URI + this.submitHoshinUrl, reviewData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            throw of(error);
        }));
    };
    /** For service call to save hoshin goals
  * @class HoshinBudgetService
  * @method saveHoshinGoals
  * @param goalData
  * @returns Observable
  */
    HoshinBudgetService.prototype.saveHoshinGoals = function (goalData) {
        return this.http.post(this.URI + this.saveHoshinGoalsUrl, goalData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            throw of(error);
        }));
    };
    /** For service call to save hoshin goals
  * @class HoshinBudgetService
  * @method saveHoshinGoals
  * @param goalData
  * @returns Observable
  */
    HoshinBudgetService.prototype.saveHoshinInitiative = function (initiativeData) {
        return this.http.post(this.URI + this.saveHoshinInitiativeUrl, initiativeData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            throw of(error);
        }));
    };
    /** For service call to save hoshin kpi
  * @class HoshinBudgetService
  * @method saveHoshinKpi
  * @param goalData
  * @returns Observable
  */
    HoshinBudgetService.prototype.saveHoshinKpi = function (kpiData) {
        return this.http.post(this.URI + this.saveHoshinKpiUrl, kpiData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            throw of(error);
        }));
    };
    /** For service call to save hoshin kpi
 * @class HoshinBudgetService
 * @method saveHoshinKpi
 * @param goalData
 * @returns Observable
 */
    HoshinBudgetService.prototype.approveorRejectHoshin = function (approvalData) {
        return this.http.post(this.URI + this.approveorRejectHoshinUrl, approvalData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            throw of(error);
        }));
    };
    /** For service call to delete hoshin
* @class HoshinBudgetService
* @method saveHoshinKpi
* @param goalData
* @returns Observable
*/
    HoshinBudgetService.prototype.deleteHoshinInitative = function (userId, hoshinId) {
        return this.http.post("" + this.URI + this.deleteHoshinInitativeUrl + hoshinId + "/" + userId, {}, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            throw of(error);
        }));
    };
    /** For service call to delete hoshin
* @class HoshinBudgetService
* @method saveHoshinKpi
* @param goalData
* @returns Observable
*/
    HoshinBudgetService.prototype.deleteHoshinKpi = function (hoshinId, kpiId, userId) {
        return this.http.post("" + this.URI + this.deleteHoshinKpiUrl + hoshinId + "/" + kpiId + "/" + userId, {}, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            throw of(error);
        }));
    };
    /** For service call to get hoshins
    * @class HoshinBudgetService
    * @method getCloneHoshins
    * @param budgetId
    * @returns Observable
    */
    HoshinBudgetService.prototype.getCloneHoshins = function (budgetId) {
        return this.http.get("" + this.URI + this.getCloneHoshinsUrl + budgetId, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            throw of(error);
        }));
    };
    /** For service call to get budget list
    * @class HoshinBudgetService
    * @method getBudgetListing
    * @param landingDTO
    * @returns Observable
    */
    HoshinBudgetService.prototype.getBudgetListing = function (landingDTO) {
        return this.http.post(this.URI + this.getBudgetList, landingDTO, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            throw of(error);
        }));
    };
    /** For service call to delete budget
     * @class HoshinBudgetService
     * @method deleteClick
     * @param landingDTO
     * @returns Observable
     */
    HoshinBudgetService.prototype.deleteBudget = function (id) {
        return this.http.delete(this.URI + this.deleteBudgetUrl + id, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            throw of(error);
        }));
    };
    /** For service call to get hoshin for pop up
     * @class HoshinBudgetService
     * @method getBaseHoshinMasterForHoshinId
     * @param hoshinId
     * @returns Observable
     */
    HoshinBudgetService.prototype.getBaseHoshinMasterForHoshinId = function (hoshinId) {
        return this.http.post(this.URI + this.getBaseHoshinMasterForHoshinIdUrl + hoshinId, {}, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            throw of(error);
        }));
    };
    /** For service call to get chapters list in hoshins table
     * @class HoshinBudgetService
     * @method getHoshinChapterListing
     * @param hoshinId
     * @returns landingDTO
     */
    HoshinBudgetService.prototype.getHoshinChapterListing = function (landingDTO) {
        return this.http.post(this.URI + this.getHoshinChaptersUrl, landingDTO, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            throw of(error);
        }));
    };
    HoshinBudgetService.prototype.getAllChapterBudgetStatuses = function (requestDTO) {
        return this.http.post(this.URI + this.getAllChapterBudgetStatusesUrl, requestDTO, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            throw of(error);
        }));
    };
    HoshinBudgetService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function HoshinBudgetService_Factory() { return new HoshinBudgetService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.BpgCommonService)); }, token: HoshinBudgetService, providedIn: "root" });
    return HoshinBudgetService;
}());
export { HoshinBudgetService };
